import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PortalApiService } from '@app/shared/services/portal-api.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { catchError, throwError } from 'rxjs';

@Component({
    selector: 'new-version-info',
    imports: [],
    templateUrl: './new-version-info.component.html',
    styleUrl: './new-version-info.component.scss'
})
export class NewVersionInfoComponent implements OnInit {
    #destroyRef = inject(DestroyRef)
    #bsModalRef = inject(BsModalRef)
    #portalApiService = inject(PortalApiService)

    notificationId?: number
    subject: string = ''
    message: string = ''
    signature: string = ''

    ngOnInit(): void {
        this.getPortalNotification_LatestNewVersion()
    }

    close(): void {
        this.#bsModalRef.hide()
    }

    private getPortalNotification_LatestNewVersion(): void {

        this
            .#portalApiService.getNotificationLatestNewVersion()
            .pipe(
                catchError((err) => {
                    this.close()
                    return throwError(() => err)
                }),
                takeUntilDestroyed(this.#destroyRef)
            )
            .subscribe({
                next: (response: any) => {
                    const notification = response
                    if (notification && notification?.ID > 0) {

                        const publishedDate = new Date(notification.PUBLISHDATETIME).toLocaleDateString();
                        const publishedTime = new Date(notification.PUBLISHDATETIME).toLocaleTimeString();

                        this.subject = notification.SUBJECT;
                        this.signature = publishedDate + ' ' + publishedTime + ' - ' + notification.USERFULLNAME + ' - ' + notification.COMPANY;
                        var message = notification.MESSAGE;

                        if (message != undefined) {
                            message = message.replace(/(?:\r\n|\r|\n)/g, '<br />');
                        }

                        this.message = message;
                        this.notificationId = notification.ID;
                    }
                },
                error: (err) => {
                    console.error('getPortalNotification_LatestNewVersion', JSON.stringify(err))
                }
            })
    }
}
